import React, { ContextType } from "react";

import DesktopContainerDrawer from "containers/DesktopContainerDrawer";
import MobileContainerDrawer from "containers/MobileContainerDrawer";
import CartContext from "contexts/CartContext";

import CartItemDesktop from "./CartItemDesktop";
import CartItemMobile from "./CartItemMobile";

interface CartItemProps {
	props?: any;
	cartItem: ContextType<typeof CartContext>["cartItems"][number];
}

const CartItem = (props: CartItemProps) => {
	return (
		<>
			<DesktopContainerDrawer>
				<CartItemDesktop {...props} />
			</DesktopContainerDrawer>
			<MobileContainerDrawer>
				<CartItemMobile {...props} />
			</MobileContainerDrawer>
		</>
	);
};

export default CartItem;
